module.exports = __webpack_public_path__ + "static/media/logo-ufinity.ef7a6a51.png";